module.exports = "<p>\n  Midnightmarmalade is a place to store lists of all those places which you have visted and enjoyed or read about, seen on TV or freinds have sugegsted that one day you think may be worth a visit. You can share your list with friends too.\n</p>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.html
// module id = ./src/app/about/about.component.html
// module chunks = main